import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "./rendom_code";
import { deleteFileByUid } from "./deleteFileByUid";
import imageCompression from "browser-image-compression";

export const Uploader_files = async (data) => {
  const { file,servicetablename,tablename, fileuid, filename, old_file_uid } = data || {};

  if (!fileuid?.trim()) return { success: false, error: "Missing fileUID" };
  if (!file) return { success: false, error: "Missing file" };
  if (!tablename?.trim()) return { success: false, error: "Missing tablename" };
  if (!filename?.trim()) return { success: false, error: "Missing filename" };

  // Only images + mp4 allowed 
  if (
    !(
      file.type.startsWith("image/") ||
      file.type === "video/mp4"
    )
  ) {
    return { success: false, error: "Only image and .mp4 video files are allowed!" };
  }
    
  // Compress if >1MB
  let uploadFile = file;
  if (file.size > 1 * 1024 * 1024) {
    try {
      uploadFile = await imageCompression(file, {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      });

      if (uploadFile.size > 1 * 1024 * 1024) {
        return { success: false, error: "File is still over 1MB after compression!" };
      }
    } catch (err) {
      return { success: false, error: "Image compression failed: " + err.message };
    }
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");
  
  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!companyuid || companyuid === "undefined") {
    return { success: false, error: "Please select company." };
  }

  try {
    const storage = getStorage();
    const uid = Randomcode(22);
    const filename_url = `${uid}.${uploadFile.name.split(".").pop()}`;
    const storageRef = ref(storage, `uploadsfiles/${companyuid+"/"+filename_url}`);

    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, uploadFile);

      uploadTask.on(
        "state_changed",
        null,
        (err) => reject({ success: false, error: err.message || err }),
        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);

            // 1. Save file metadata under company
            const fileDocRef = doc(
              db,
              servicetablename,
              companyuid,
              "files",
              uid
            );

            await setDoc(fileDocRef, {
              uid,
              companyuid,
              tablename,
              fileuid,
              filename,
              url,
              size: uploadFile.size,
              type: uploadFile.type,
              guid,
              sessiontoken,
              date_time: new Date(),
            }, { merge: true });

            // 2. Update table document also under company
            const updateDocRef = doc(
              db,
              servicetablename,
              companyuid,
              tablename,
              fileuid
            );

            await setDoc(updateDocRef, {
              [`${filename}_url`]: url,
              [`${filename}_uid`]: uid,
            }, { merge: true });

            // 3. Delete old file if exists
            if (old_file_uid != null && old_file_uid?.trim() && old_file_uid !== uid) {
              deleteFileByUid(old_file_uid,servicetablename);
            }

            resolve({ success: true, fileurl: url });

          } catch (firestoreErr) {
            reject({ success: false, error: firestoreErr.message });
          }
        }
      );
    });
  } catch (err) {
    return { success: false, error: err.message || err };
  }
};
